import React from 'react'

import Info from '@interco/icons/dist/build-v4/orangeds/SM/info'
import ArrowLeft from '@interco/icons/dist/build-v4/orangeds/SM/arrow-left'
import Home from '@interco/icons/dist/build-v4/orangeds/SM/home'
import Loading from '@interco/icons/dist/build-v4/orangeds/MD/loading'
import ArrowRight from '@interco/icons/dist/build-v4/orangeds/MD/arrow-right'
import ArrowLefts from '@interco/icons/dist/build-v4/orangeds/MD/arrow-left'
import ChevronRight from '@interco/icons/dist/build-v4/orangeds/MD/chevron-right'
import ChevronUp from '@interco/icons/dist/build-v4/orangeds/MD/chevron-up'
import ChevronDown from '@interco/icons/dist/build-v4/orangeds/MD/chevron-down'
import Help from '@interco/icons/dist/build-v4/orangeds/XL/help'
import Download from '@interco/icons/dist/build-v4/orangeds/MD/download'
import Share from '@interco/icons/dist/build-v4/orangeds/MD/share'
import Email from '@interco/icons/dist/build-v4/orangeds/MD/email'
import Copy from '@interco/icons/dist/build-v4/orangeds/MD/copy'
import Receipt from '@interco/icons/dist/build-v4/orangeds/MD/receipt'
import Check from '@interco/icons/dist/build-v4/orangeds/MD/check'
import CheckCircle from '@interco/icons/dist/build-v4/orangeds/SM/check-circle'
import CheckSuccess from '@interco/icons/dist/build-v4/orangeds/SM/check-success'
import IcCheckCircleFill from '@interco/icons/dist/core/status/ic_check_circle_fill'
import IcPadlock from '@interco/icons/dist/core/privacy-security/ic_padlock'
import IcCloseCircleFill from '@interco/icons/dist/core/status/ic_close_circle_fill'
import IcHistory from '@interco/icons/dist/core/action-navigation/ic_history'
import IcHandMoney from '@interco/icons/dist/core/human/ic_hand_money'
import IcCoin from '@interco/icons/dist/core/finance/ic_coin'
import IcEyeClosed from '@interco/icons/dist/core/action-navigation/ic_eye_closed'
import IcEyeOpen from '@interco/icons/dist/core/action-navigation/ic_eye_open'
import IcRotateMoney from '@interco/icons/dist/core/finance/ic_rotate_money'
import IcMoneyCheckPointer from '@interco/icons/dist/core/finance/ic_money_check_pointer'
import IcPigBank from '@interco/icons/dist/core/finance/ic_piggy_bank'
import IcMoneyCheck from '@interco/icons/dist/core/finance/ic_money_check'
import IcShoppingCart from '@interco/icons/dist/core/shopping/ic_shopping_cart'
import IcGlobe from '@interco/icons/dist/core/home-objects/ic_globe'
import IcInterLoop from '@interco/icons/dist/core/brands/ic_inter_loop'
import IcRotateCheck from '@interco/icons/dist/core/action-navigation/ic_rotate_check'
import IcCalendarMoney from '@interco/icons/dist/core/action-navigation/ic_calendar_money'
import IcPiggyMoney from '@interco/icons/dist/core/finance/ic_piggy_money'
import IcPix from '@interco/icons/dist/core/brands/ic_pix'
import IcHandshake from '@interco/icons/dist/core/human/ic_handshake'
import IcMoneyCheckArrowDown from '@interco/icons/dist/core/finance/ic_money_check_arrow_down'
import IcTrendingUpFill from '@interco/icons/dist/core/finance/ic_trending_up_fill'
import IcStopwatch from '@interco/icons/dist/core/action-navigation/ic_stopwatch'
import IcGiftMoney from '@interco/icons/dist/core/shopping/ic_gift_money'
import IcInfoCircle from '@interco/icons/dist/core/status/ic_info_circle'
import IcHouseCheck from '@interco/icons/dist/core/finance/ic_house_check'
import IcMenu from '@interco/icons/dist/core/action-navigation/ic_menu'
import IcCarFront from '@interco/icons/dist/core/travel-mobility/ic_car_front'
import IcScore from '@interco/icons/dist/core/finance/ic_score'
import IcTrendingUp from '@interco/icons/dist/core/finance/ic_trending_up'
import IcHouseHalf from '@interco/icons/dist/core/finance/ic_house_half'
import IcHandHouse from '@interco/icons/dist/core/human/ic_hand_house'
import IcCityHall from '@interco/icons/dist/core/travel-mobility/ic_city_hall'
import IcEllipsis from '@interco/icons/dist/core/action-navigation/ic_ellipsis'

export const Icons: Record<string, (props: IconProps) => JSX.Element | null> = {
  info: (props: IconProps) => <Info data-testid="info" {...props} />,
  ic_info_circle: (props: IconProps) => <IcInfoCircle data-testid="ic_info_circle" {...props} />,
  leftarrow: (props: IconProps) => <ArrowLeft data-testid="leftarrow" {...props} />,
  home: (props: IconProps) => <Home data-testid="home" {...props} />,
  loading: (props: IconProps) => <Loading data-testid="loading" {...props} />,
  arrowright: (props: IconProps) => <ArrowRight data-testid="arrowright" {...props} />,
  arrowleft: (props: IconProps) => <ArrowLefts data-testid="arrowleft" {...props} />,
  chevronright: (props: IconProps) => <ChevronRight data-testid="chevronright" {...props} />,
  chevronup: (props: IconProps) => <ChevronUp data-testid="chevronup" {...props} />,
  chevrondown: (props: IconProps) => <ChevronDown data-testid="chevrondown" {...props} />,
  help: (props: IconProps) => <Help data-testid="help" {...props} />,
  download: (props: IconProps) => <Download data-testid="download" {...props} />,
  share: (props: IconProps) => <Share data-testid="share" {...props} />,
  email: (props: IconProps) => <Email data-testid="email" {...props} />,
  copy: (props: IconProps) => <Copy data-testid="copy" {...props} />,
  receipt: (props: IconProps) => <Receipt data-testid="receipt" {...props} />,
  check: (props: IconProps) => <Check data-testid="check" {...props} />,
  checkcircle: (props: IconProps) => <CheckCircle data-testid="checkcircle" {...props} />,
  checksuccess: (props: IconProps) => <CheckSuccess data-testid="checksuccess" {...props} />,
  checkcirclev2: (props: IconProps) => <IcCheckCircleFill data-testid="checkcirclev2" {...props} />,
  lock: (props: IconProps) => <IcPadlock data-testid="lock" {...props} />,
  close: (props: IconProps) => <IcCloseCircleFill data-testid="close" {...props} />,
  process: (props: IconProps) => <IcHistory data-testid="process" {...props} />,
  ic_hand_money: (props: IconProps) => <IcHandMoney data-testid="ic_hand_money" {...props} />,
  iccoin: (props: IconProps) => <IcCoin data-testid="ichandcoin" {...props} />,
  iceyeclosed: (props: IconProps) => <IcEyeClosed data-testid="iceyeclosed" {...props} />,
  iceyeopen: (props: IconProps) => <IcEyeOpen data-testid="iceyeopen" {...props} />,
  icrotatemoney: (props: IconProps) => <IcRotateMoney data-testid="icrotatemoney" {...props} />,
  ic_money_check_pointer: (props: IconProps) => (
    <IcMoneyCheckPointer data-testid="ic_money_check_pointer" {...props} />
  ),
  ic_piggy_bank: (props: IconProps) => <IcPigBank data-testid="ic_pig_bank" {...props} />,
  ic_money_check: (props: IconProps) => <IcMoneyCheck data-testid="ic_money_check" {...props} />,
  ic_inter_loop: (props: IconProps) => <IcInterLoop data-testid="ic_inter_loop" {...props} />,
  ic_globe: (props: IconProps) => <IcGlobe data-testid="ic_globe" {...props} />,
  ic_shopping_cart: (props: IconProps) => (
    <IcShoppingCart data-testid="ic_shopping_cart" {...props} />
  ),
  ic_rotate_check: (props: IconProps) => <IcRotateCheck data-testid="ic_rotate_check" {...props} />,
  ic_calendar_money: (props: IconProps) => (
    <IcCalendarMoney data-testid="ic_calendar_money" {...props} />
  ),
  ic_piggy_money: (props: IconProps) => <IcPiggyMoney data-testid="ic_piggy_money" {...props} />,
  ic_pix: (props: IconProps) => <IcPix data-testid="ic_pix" {...props} />,
  ic_handshake: (props: IconProps) => <IcHandshake data-testid="ic_handshake" {...props} />,
  ic_money_check_arrow_down: (props: IconProps) => (
    <IcMoneyCheckArrowDown data-testid="ic_money_check_arrow_down" {...props} />
  ),
  ic_trending_up_fill: (props: IconProps) => (
    <IcTrendingUpFill data-testid="ic_trending_up_fill" {...props} />
  ),
  ic_stopwatch: (props: IconProps) => <IcStopwatch data-testid="ic_stopwatch" {...props} />,
  ic_gift_money: (props: IconProps) => <IcGiftMoney data-testid="ic_gift_money" {...props} />,
  ic_house_check: (props: IconProps) => <IcHouseCheck data-testid="ic_house_check" {...props} />,
  ic_menu: (props: IconProps) => <IcMenu data-testid="ic_menu" {...props} />,
  ic_car_front: (props: IconProps) => <IcCarFront data-testid="ic_car_front" {...props} />,
  ic_score: (props: IconProps) => <IcScore data-testid="ic_score" {...props} />,
  ic_trending_up: (props: IconProps) => <IcTrendingUp data-testid="ic_trending_up" {...props} />,
  ic_house_half: (props: IconProps) => <IcHouseHalf data-testid="ic_house_half" {...props} />,
  ic_hand_house: (props: IconProps) => <IcHandHouse data-testid="ic_hand_house" {...props} />,
  ic_city_hall: (props: IconProps) => <IcCityHall data-testid="ic_city_hall" {...props} />,
  ic_ellipsis: (props: IconProps) => <IcEllipsis data-testid="ic_ellipsis" {...props} />,
}

export interface IconProps {
  color?: string
  name: string
  width?: number
  height?: number
  onClick?: () => void
}

export const Icon = (props: IconProps) => {
  const { name, color, width, height, onClick } = props
  const IconComponent = Icons[name.toLowerCase().replace(/-/g, '')]
  if (IconComponent) return IconComponent({ ...props, name, color, width, height, onClick })
  return <span data-testid="no-icon" />
}
